import { render, staticRenderFns } from "./Slice--ScrollPoint.vue?vue&type=template&id=b0d52f7c&lang=pug&"
import script from "./Slice--ScrollPoint.vue?vue&type=script&lang=js&"
export * from "./Slice--ScrollPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports